import React, {Component} from "react";  import config from 'react-global-configuration';
import {MenuItem, Nav, NavDropdown, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import Moment from "react-moment";
import axios from "axios";
import {Scrollbars} from 'react-custom-scrollbars';
import {isMobile} from "react-device-detect";
import hdfc_logo from "assets/img/HDFC_logo.png";
class AdminNavbarLinks extends Component {
        constructor(props) {
        super(props);
        this.state = {
            user_type: '',
            userName: '',
            user_notifications:[],
            allNotifications:[
                // {heading:"Funds Being put on hold","text":"Settlement of transactions for terminal C0001 has been put on hold by Bank."},
                // {heading:"Funds has been settled","text":"Rs 20000.00 transferred to your bank account xxxxxxxx1234 against your terminal C0001 transaction"},
            
               ],
               nitify:[]
        };
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        try {
            const decoded = jwt_decode(token);
            this.setState({
                userName: decoded.firstName + ' ' + decoded.lastName,
                user_type: decoded.userGroupName==='SRO'?decoded.userSubGroupName:decoded.userGroupName,
                userSubGroupName: decoded.userSubGroupName
            });
            this.userNotifications();
        } catch (err) {
            console.log("expired check failed!");
        }

    }
    userNotifications() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

            axios.get(config.get('API_URL')+'/masterdata/all_notifications/', {
                params: {
                    user_id: decoded._id
                },
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
                this.setState({
                    user_notifications:response.data
                })
            }).catch(err => {
                console.log(err);
            });

    }
    changeViewStatus() {
        var  localNotofication=[];
        this.state.allNotifications.splice(0, this.state.allNotifications.length)
        localNotofication.push(JSON.parse(localStorage.getItem("notfications")));
        if(localNotofication[0]!==null)
        {
        localNotofication[0].map((val,key) =>{
            this.state.allNotifications.push(val)
        })
        this.setState({notify:localNotofication})
    }
        console.log("local : "+this.state.notify)
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL')+'/masterdata/update_notifications_status/', {
            params: {
                user_id: decoded._id
            },
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            //console.log(response);
            this.userNotifications();

        }).catch(err => {
            console.log(err);
        });
    }
    removeDiv =(event) =>{
        var id=document.getElementById((event.target.id));
      id.remove();
    }
    render() {
        let notificationText='';
        let countUnseen = 0;
        if(Array.isArray(this.state.user_notifications) && this.state.user_notifications.length) {
            //if(this.state.user_notifications.length
            notificationText = this.state.user_notifications.map((val, i) => {
                if (val.status == 'not viewed') {
                    countUnseen++;
                }
                return (
                    <MenuItem eventKey={2.1} key={i + 1} componentClass={Link} href={"/admin/notifications/"+ val.notification_id } to={"/admin/notifications/"+ val.notification_id }>
                        <p>{val.message} </p>
                        <p><span className="pe-7s-clock bell-notification"></span><Moment
                            format='MMMM Do YYYY, h:mm:ss a'>{val.created_at}</Moment></p>
                    </MenuItem>
                );
            });
        }
        else{
            notificationText = this.state.allNotifications.map((val,index)=>{
                return (
                      <div style={{padding:'10px',backgroundColor:'#32327d',color:'#fff',borderRadius:'5px',margin:'10px'}} id={index}>
                          {/* <div><h4>{val.heading}</h4></div> */}
                          <p style={{margin:'0px', padding: '0px 5px',display:'inline-block',fontSize:'14px'}}>{val.heading}</p>
                          <span id={index} onClick={this.removeDiv.bind(this)} style={{ cursor: 'pointer',display:'inline-block',fontFamily: 'Arial', fontSize: '17px', position: 'absolute', right: '15px' ,lineHeight: '15px', backgroundColor:'rgb(19 6 97)',fontWeight:'600', color: 'rgb(240, 245, 234)', borderRadius: '50%', width: '14px', height: '14px' ,fontWeight: 'bold', textAlign: 'center'}}>×</span>
                          <p style={{margin:'0px', padding: '0px 5px',display:'inline-block'}}>{val.text}</p>
                      </div>
                );
            })
        }
        const notification = (
            <div>
                <i className="fa fa-bell"></i>
                <b className="caret" />
                {countUnseen>0?
                <span className="notification">{countUnseen}</span>
                    : null }
                <p className="hidden-lg hidden-md">Notification</p>
            </div>
        );
        return (
            <div>
                <button className="navbar-sidebar-toggler" type="button" onClick={ () => document.body.classList.toggle('sidebar-icon-only') }>
                    <i class="fa fa-bars"></i>
                </button>
                <div className="pname">
                { this.state.userSubGroupName==='Refund Module Admin' || this.state.userSubGroupName==='Refund Module Admin With Reports' || this.state.userSubGroupName==='Refund Module Operator' || this.state.userSubGroupName==='Refund Module Operator With Reports' ?
                <img src={hdfc_logo} alt="logo_image" style={{width:'55%'}}/>: null}
                </div>

                <Nav pullRight>
                    {!isMobile &&
                    <NavDropdown
                        eventKey={2}
                        title={notification}
                        noCaret
                        id="basic-nav-dropdown-right"
                        onClick={this.changeViewStatus.bind(this)}
                    >
                        <Scrollbars style={{minHeight:'400px',maxHeight:'100%'}}
                        >
                            <p style={{textAlign:'center',borderBottom:'1px solid #808080a8',textTransform:'uppercase',fontWeight:'600',padding:'3px'}}>All Notifications</p>
                            {notificationText}
                        </Scrollbars>
                    </NavDropdown>}
                    {this.state.user_type=='DMS' || this.state.user_type=='Lounge'?null:
                    <NavItem eventKey={5} href="/admin/report-download-queue/">
                        <i className="fa fa-download"></i>
                    </NavItem>}
                    <NavItem eventKey={5} href="/admin/user-profile/">
                        <i className="fa fa-user"></i>&nbsp;{this.state.userName} ({this.state.user_type})
                    </NavItem>

                    <NavItem eventKey={3} href="/admin/logout/">
                        <i className="fa fa-sign-out"></i> &nbsp;
                            Log out
                    </NavItem>
                </Nav>
                 <div className="clearfix"></div>
            </div>
        );
    }
}
export default AdminNavbarLinks;
